import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, startWith, timeout } from 'rxjs/operators';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent, MatLegacyAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/legacy-autocomplete';
import { BasicWithLibelleModel } from '../../../models/basic/basicWithLibelle.model';
import * as util from '../../../constants/util';


@Component({
  selector: 'app-autocomplete-with-code-libelle-form',
  templateUrl: './autocomplete-with-code-libelle-form.component.html',
  styleUrls: ['./autocomplete-with-code-libelle-form.component.scss']
})
export class AutoCompleteWithCodeLibelleFormComponent implements OnChanges {

  @Input() objets: BasicWithLibelleModel[];
  @Input() objet: BasicWithLibelleModel;
  @Input() selectedObjet: BasicWithLibelleModel[];
  @Input() required: boolean;
  @Input() codeControlName: string;
  @Input() libelleControlName: string;
  @Input() parent: UntypedFormGroup;
  @Input() libelle: string;
  @Input() styles = false;
  @Output() objetChange = new EventEmitter<BasicWithLibelleModel>();
  @ViewChild('matInput') matInput: ElementRef<HTMLInputElement>;
  public util = util;
  objetsString: string[] = [];
  filteredObjets: Observable<string[]>;
  myControl = new UntypedFormControl();

  itemSelected: any = null;
  @Output() changeEvent = new EventEmitter<any>();
  codeControl: AbstractControl;
  libelleControl: AbstractControl;
  @Input() articlePrefix = '';

  constructor() {

  }

  reLoadObjets(): void {
    this.objetsString = [];
    if (this.objets) {
      for (const objet of this.objets) {
        this.objetsString.push(objet.code + '-' + objet.libelle);
      }
      this.objetsString.sort((a, b) => a.localeCompare(b));
      this.filteredObjets = this.myControl.valueChanges.pipe(
        startWith(null),
        map((obj: string | null) => obj ? this._filter(obj) : this.objetsString.slice(0, 30)));
    }
  }

  setValidators(): void {
    if (this.objets && this.objets.length > 0) {
      this.myControl.enable();
      const validators = [];
      validators.push(forbiddenNamesValidator(this.objets));
      if (util.hasRequiredField(this.codeControl)) {
        validators.push(Validators.required);
      }
      this.myControl.setValidators(validators);
    } else {
      this.myControl.disable();
    }
    if (this.codeControl.disabled) {
      this.myControl.disable();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.parent && this.codeControlName && this.libelleControlName) {
      this.codeControl = this.parent.get(this.codeControlName);
      this.libelleControl = this.parent.get(this.libelleControlName);
      this.reLoadObjets();
      this.setValidators();
      if (this.codeControl && this.libelleControl) {
        this.parent.setControl(this.codeControlName + this.libelleControlName, this.myControl);
        if (this.codeControl.value && this.libelleControl.value) {
          this.myControl.setValue(this.codeControl.value + '-' + this.libelleControl.value);
        }
        if (this.codeControl.disabled) {
          this.myControl.disable();
        }
        combineLatest([this.codeControl.valueChanges, this.libelleControl.valueChanges])
        .subscribe(([code, libelle]) => {
          if (this.codeControl.value && this.libelleControl.value) {
            this.myControl.setValue(code + '-' + libelle);
          } else {
            this.myControl.setValue('');
          }
          this.setValidators();
        });
      }
    }
  }

  onObjetChange(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.viewValue;
    const objet = this.objets.find(obj => obj.code + '-' + obj.libelle === value);
    if (objet) {
      this.codeControl.setValue(objet.code);
      this.libelleControl.setValue(objet.libelle);
    }
    this.matInput.nativeElement.blur();
    this.reLoadObjets();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    const objSelected = this.objetsString.find(obj => obj.toLowerCase() === filterValue);
    if (objSelected){
      return this.objetsString.slice(0, 30);
    } else {
      return this.objetsString.filter(obj => obj.toLowerCase().indexOf(filterValue) >= 0).slice(0, 30);
    }
  }

  deleteIfEmpty(): void {
    this.libelleControl.setValue('');
    this.codeControl.setValue('');
  }
}


export function forbiddenNamesValidator(names: BasicWithLibelleModel[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // below findIndex will check if control.value is equal to one of our options or not
    if (control.value && names) {
      const index = names.findIndex(name => {
        return (name.code + '-' + name.libelle).localeCompare(control.value) === 0;
      });
      return index < 0 ? { 'forbiddenNames': { value: control.value } } : null;
    } else {
      return null;
    }
  };
}
